class HomeSeries extends HTMLElement {
  constructor() {
    super();
    const { autoplay, autoplaySpeed, totalSize } = $(this).data();
    this.autoplay = autoplay;
    this.autoplaySpeed = autoplaySpeed;
    this.totalSize = totalSize;
    this.index = 0;
    this.timer = null;
    this.init();
  }
  init() {
    if (this.autoplay) {
      this.autoplayEvent();
    }
    $(this)
      .find('.nav-item')
      .on('click', e => {
        const { index } = e.target.dataset;
        this.changeNav(index);
        clearInterval(this.timer);
      });
  }
  changeNav(index) {
    this.index = index;
    $(this).find('.nav-item').removeClass('active');
    $(this).find('.nav-item').eq(index).addClass('active');
    $(this).find('.series-box-content-inner').css({
      '-webkit-transform': `translateX(${-(index / this.totalSize * 100)}%)`,
      'transform': `translateX(${-(index / this.totalSize * 100)}%)`
    })
  }
  autoplayEvent() {
    this.timer = setInterval(() => {
      if (this.totalSize > this.index + 1) {
        this.changeNav(this.index + 1);
      } else {
        this.changeNav(0);
      }
    }, this.autoplaySpeed * 1000);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  if (!customElements.get('home-series')) {
    customElements.define('home-series', HomeSeries);
  }
});
